import Command from './Command';

export default class NopCommand extends Command {
  constructor(public id: number, public sceneId: number) {
    super(id, sceneId);
  }
}
